var React = require('react');

function PropertyInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M59.5 14H13V6c0-1.1.9-2 2-2s2 .9 2 2c0 .8.7 1.5 1.5 1.5S20 6.8 20 6c0-2.8-2.2-5-5-5s-5 2.2-5 5v8H1.5c-.8 0-1.5.7-1.5 1.5S.7 17 1.5 17H2v13.5c0 7.1 5.5 12.9 12.4 13.4l-.3 1.1c-.3.8.2 1.6.9 1.9.2.1.3.1.5.1.6 0 1.2-.4 1.4-1l.7-2h25.8l.7 2c.2.6.8 1 1.4 1 .2 0 .3 0 .5-.1.8-.3 1.2-1.1.9-1.9l-.4-1.1c7-.5 12.5-6.3 12.5-13.4V17h.5c.8 0 1.5-.7 1.5-1.5s-.7-1.5-1.5-1.5zm-16 3v7h-3v-7h3zm-6 0v8.5c0 .8.7 1.5 1.5 1.5h6c.8 0 1.5-.7 1.5-1.5V17h3v13h-15V17h3zM56 30.5C56 36.3 51.3 41 45.6 41l-.7-2c-.3-.8-1.1-1.2-1.9-.9-.8.3-1.2 1.1-.9 1.9l.3 1H18.6l.3-1c.3-.8-.2-1.6-.9-1.9-.8-.3-1.6.2-1.9.9l-.7 2C9.7 41 5 36.3 5 30.5V17h26.5v14.5c0 .8.7 1.5 1.5 1.5h18c.8 0 1.5-.7 1.5-1.5V17H56v13.5z","fill":"#5f29c7"}));
}

PropertyInline.defaultProps = {"width":"61","height":"48"};

module.exports = PropertyInline;

PropertyInline.default = PropertyInline;
